module.exports = __webpack_public_path__ + "static/img/reward-bg.a907ef00.jpg";